import { render, staticRenderFns } from "./DetailMembertype.vue?vue&type=template&id=0b658fa7"
import script from "./DetailMembertype.vue?vue&type=script&lang=js"
export * from "./DetailMembertype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports